import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_vat_summary_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons"

const VatSummaryReport = () => {
  let location = useLocation();
  let componentRef = useRef();  

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Invoices",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "customer",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Customer",
        api: "get-all-customers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: new Date(),
          end: new Date(),
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        customer: tabledata?.customer,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_vat_summary_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <div className="text-right pb-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500 w-36"
                  type="button"
                  size="large"
                >
                  Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef.current}
              pageStyle={`
              @page {
                size: landscape;
                margin: 20mm;
              }
                table {
                border-collapse: collapse;
                width: 100%;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 6px;
              }
              th {
                background-color: #f4f4f4;
              }
            `}
            />
          </div>
        </div>
        <div ref={componentRef}>
        <div>
          <div className="text-medium py-2">SALES VAT</div>
          <table className="w-full bg-white">
            <thead className="text-gray-500">
              <tr>
                <td className="border p-4">Taxable&nbsp;Amount</td>
                <td className="border p-4">Vat&nbsp;Amount</td>
                <td className="border p-4 text-right">
                  Total&nbsp;With&nbsp;Vat
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-4">{body?.sales?.taxable_amount}</td>
                <td className="border p-4">{body?.sales?.vat_amount}</td>
                <td className="border p-4 text-right">
                  {body?.sales?.total_with_vat}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div className="text-medium py-2">Purchase VAT</div>
          <table className="w-full bg-white">
            <thead className="text-gray-500">
              <tr>
                <td className="border p-4">Taxable&nbsp;Amount</td>
                <td className="border p-4">Vat&nbsp;Amount</td>
                <td className="border p-4 text-right">
                  Total&nbsp;With&nbsp;Vat
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-4">
                  {body?.purchases?.taxable_amount}
                </td>
                <td className="border p-4">{body?.purchases?.vat_amount}</td>
                <td className="border p-4 text-right">
                  {body?.purchases?.total_with_vat}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <div className="text-medium py-2">NET VAT PAYABLE</div>
          <table className="w-full bg-white">
            <thead className="text-gray-500">
              <tr>
                <td className="border p-4 text-medium text-black">TOTAL</td>
                <td className="border p-4 text-medium text-black text-right">
                  {body?.net_vat_payable}
                </td>
              </tr>
            </thead>
          </table>
        </div>
        </div>
      </Loadercomponent>
    </Header>
  );
};

export default VatSummaryReport;
